import numeral from 'numeral';

/** Entier avec séparateur de milliers : `5 120`. */
export const INTEGER_FORMAT = '0,0';
/** Jusqu'à 3 décimales, sans zéros inutiles : `1 023,6`. */
export const DECIMAL_FORMAT = '0,0[.][000]';

const defaultLocale = 'fr';

export const initNumeral = () => {
  // Locale enregistrée ici plutôt qu'importée de `numeral/locales/fr` (non typée) ;
  // milliers séparés par une espace fine insécable (U+202F), comme en typographie française.
  numeral.register('locale', defaultLocale, {
    delimiters: { thousands: ' ', decimal: ',' },
    abbreviations: { thousand: 'k', million: 'M', billion: 'Md', trillion: 'Bn' },
    ordinal: value => (value === 1 ? 'er' : 'e'),
    currency: { symbol: '€' },
  });
  numeral.locale(defaultLocale);
};

const EMPTY_VALUE = '—';

/** Formate un nombre (ou un bigint SQL reçu en chaîne) ; `—` si la valeur est absente. */
export const formatNumber = (
  value: number | string | null | undefined,
  format: string = INTEGER_FORMAT,
): string => (value == null ? EMPTY_VALUE : numeral(Number(value)).format(format));
